<template>
    <y-panel
        class="m-cart__delivery-intervals mt-7"
        :title="$t('cart.delivery_intervals.title')"
        raised
    >
        <y-loading
            :active="$wait.is('loading-delivery-intervals')"
            position="relative"
            height="110px"
        >
            <template v-if="formatDeliveryIntervals && Object.keys(formatDeliveryIntervals).length">
                <div
                    v-for="(interval, key) in slicedFormatDeliveryIntervals"
                    :key="key"
                    class="interval-item"
                >
                    <p class="interval-item__label">
                        <strong class="interval-item__label__week-day">
                            {{ key.split('_')[0] }}
                        </strong>
                        <span class="interval-item__label__date">
                            {{ key.split('_')[1] }}
                        </span>
                    </p>
                    <y-radio
                        v-model="selectedIntervals"
                        color="primary"
                        :options="interval"
                        :port="false"
                        no-label
                        inline
                    />
                </div>
                <div class="limited-arrow">
                    <y-icon
                        :icon="`chevron-${limitShowIntervals < Object.keys(formatDeliveryIntervals).length ? 'down' : 'up'}`"
                        color="primary"
                        @click.native="limitShowHandler"
                    />
                </div>
            </template>

            <y-empty
                v-else
                no-image
                no-title
                :text="$t('cart.delivery_intervals.empty')"
            />
        </y-loading>
    </y-panel>
</template>

<script>
    import {
        YEmpty, YPanel, YRadio, YIcon,
    } from '@components';
    import { separated } from '@nodes/helpers/number';
    import { toJalaali } from '@nodes/helpers/date';

    export default {
        name: 'DeliveryIntervals',

        components: {
            YEmpty,
            YPanel,
            YRadio,
            YIcon,
        },

        props: {
            /**
             * List of available delivery intervals
             */
            deliveryIntervals: {
                type: Array,
            },

            /**
             * Disable section
             */
            disabled: {
                type: Boolean,
            },
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                selectedIntervals      : null,
                formatDeliveryIntervals: null,
                limitShowIntervals     : 4,
            };
        },

        computed: {
            /**
             * Slice delivery intervals
             *
             * @returns {object}
             */
            slicedFormatDeliveryIntervals() {
                const limitedIntervals = {};
                Object.keys(this.formatDeliveryIntervals).slice(0, this.limitShowIntervals).forEach((item) => {
                    limitedIntervals[item] = this.formatDeliveryIntervals[item];
                });
                return limitedIntervals;
            },
        },

        watch: {
            deliveryIntervals: {
                /**
                 * Reset Selected intervals
                 *
                 * @param {*} newValue
                 * @param {*} oldValue
                 */
                handler(newValue, oldValue) {
                    if (!this.isEqual(oldValue, newValue)) {
                        this.selectedIntervals = null;
                        this.formatDeliveryIntervals = null;
                        const arr = {};
                        if (newValue) {
                            newValue.forEach((element) => {
                                if (arr[toJalaali(element.starts_at, 'dddd _ jD jMMMM')]) {
                                    arr[toJalaali(element.starts_at, 'dddd _ jD jMMMM')]
                                        .push({
                                            label   : this.$t('cart.delivery_intervals.times', [toJalaali(element.starts_at, 'k'), toJalaali(element.ends_at, 'k')]),
                                            value   : element.id,
                                            disabled: !element.free_capacity,
                                        });
                                } else {
                                    arr[toJalaali(element.starts_at, 'dddd _ jD jMMMM')] = [{
                                        label   : this.$t('cart.delivery_intervals.times', [toJalaali(element.starts_at, 'k'), toJalaali(element.ends_at, 'k')]),
                                        value   : element.id,
                                        disabled: !element.free_capacity,
                                    }];
                                }
                            });
                            this.formatDeliveryIntervals = arr;
                        }
                    }
                },
            },

            selectedIntervals: {
                /**
                 * Emit Selected intervals
                 *
                 * @param {*} newValue
                 * @param {*} oldValue
                 */
                handler(newValue, oldValue) {
                    if (!this.isEqual(oldValue, newValue)) {
                        this.$emit('selectedIntervals', newValue);
                    }
                },
            },
        },

        methods: {
            separated,

            /**
             * Add Style on selected intervals
             * 
             * @param {object} intervals
             * @returns {boolean}
             */
            isSelected(intervals) {
                return this.selectedIntervals?.id === intervals.id;
            },

            /**
             * Limit show handler
             */
            limitShowHandler() {
                if (this.limitShowIntervals < Object.keys(this.formatDeliveryIntervals).length) {
                    this.limitShowIntervals = Object.keys(this.formatDeliveryIntervals).length;
                } else {
                    this.limitShowIntervals = 4;
                }
            },
        },
    };
</script>
